import {gql} from '@apollo/client'

// The files directly in a folder, or at the top of the drive without one, newest first and a page
// at a time. "after" is the "endCursor" of the page before.
export const UPLOADS = gql`
  query Uploads($folderId: ID, $search: String, $first: Int, $after: String) {
    uploads(folderId: $folderId, search: $search, first: $first, after: $after) {
      nodes {
        id
        filename
        filesize
        fileType
        status
        folderId
        createdAt
        updatedAt
        openedAt
        starredAt
        thumbnail {
          url
          durationMs
          pageCount
          excerpt
          peaks
          width
          height
        }
      }
      endCursor
      hasMore
    }
  }
`

export const STARRED_UPLOADS = gql`
  query StarredUploads($search: String, $first: Int, $after: String) {
    starredUploads(search: $search, first: $first, after: $after) {
      nodes {
        id
        filename
        filesize
        fileType
        status
        folderId
        createdAt
        updatedAt
        openedAt
        starredAt
        thumbnail {
          url
          durationMs
          pageCount
          excerpt
          peaks
          width
          height
        }
      }
      endCursor
      hasMore
    }
  }
`

export const RECENT_UPLOADS = gql`
  query RecentUploads {
    recentUploads {
      id
      filename
      filesize
      fileType
      status
      folderId
      createdAt
      updatedAt
      openedAt
      starredAt
      thumbnail {
        url
        durationMs
        pageCount
        excerpt
        peaks
        width
        height
      }
    }
  }
`

// Everything that changes a file can change any listing it is in.
export const UPLOAD_LISTINGS = [UPLOADS, STARRED_UPLOADS, RECENT_UPLOADS]

export const UPLOAD = gql`
  query Upload($id: ID!) {
    upload(id: $id) {
      id
      filesize
      status
      thumbnail {
        url
        durationMs
        pageCount
        excerpt
        peaks
        width
        height
      }
    }
  }
`

// Asked for one file at a time, when its details are opened: reading them means opening the owner's
// account key, which the listings leave alone.
export const UPLOAD_DETAILS = gql`
  query UploadDetails($id: ID!) {
    upload(id: $id) {
      id
      details {
        make
        model
        lens
        software
        aperture
        exposureTime
        iso
        focalLength
        focalLength35mm
        exposureBias
        flash
        whiteBalance
        width
        height
        colourProfile
        takenAt
        latitude
        longitude
        altitude
        place
        frameRate
        videoCodec
        bitRate
        audioCodec
        sampleRate
        channels
        title
      }
    }
  }
`
